// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}


@font-face {
  font-display: swap;
}


body,
#root {
  background-color: #000000;
  margin: 0;
  box-sizing: border-box;
  overflow-x: hidden;
}


.modal-backdrop.show {
  opacity: 0 !important;
}

.modal-backdrop {
  --bs-backdrop-zindex: 0 !important;
  --bs-backdrop-bg: #1f222a;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: none !important;
  width: 100vw;
  height: 100vh;
  background-color: none !important
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f0f0f0;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #424242;
}

:is(button, p, input, label, span, select) {
  font-family: "Poppins";
}

:is(h1, h2, h3, h4, h5, h6) {
  font-family: "Poppins" !important;
}

.heightBody {
  height: 100vh;
}

/* .heightForChild {
  padding-top: 20px;
} */

.width-max {
  width: max-content;
}

.input-label {
  display: block;
  position: absolute;
  top: 0;
  font-weight: 300;
  font-size: 20px;
  font-family: "Poppins";
}

.loaderAll {
  height: 100vh;
  width: 100%;
}

.loaderAll>img {
  width: 150px;
  height: 150px;
  object-fit: cover;
}

.bannerText {
  font-family: "Poppins" !important;
  font-size: 10px !important;
  font-weight: 500 !important;
  line-height: 13px !important;
  position: relative !important;
  background-color: rgb(45 48 56 / 0%) !important;
  border: 1px solid white !important;
}

.donate-tab {
  position: fixed;
  right: 0;
  top: 20vh;
  z-index: 1040;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 10px;
  border: none;
  border-radius: 10px 0 0 10px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
}

/* Vertical text: bottom to top */
.donate-tab .label {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 1px;
}

.heart-icon {
  transform: rotate(-90deg);
}


.homePageCardHeading {
  font-family: "Poppins";
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
  margin-bottom: 0px;
  height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: nowrap;
}

.homePageCardHeading::after {
  display: none;
}

.homeListImage {
  width: 100%;
  height: 180px;
  object-fit: cover;
  position: relative;
}

.homeListImage::after {
  content: "";
  width: 100%;
  display: block;
  position: absolute;
  bottom: 0;
  height: 70%;
}

.homeListImage.active::after {
  height: 40%;
}

.homeLiveImage {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 3px;
}

.homeListContent {
  z-index: 1;
}

.homeListButton {
  padding: 10px 15px;
  border-radius: 5px;
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}

.homeListButtonText {
  font-family: "Poppins";
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
}


.homeListText {
  font-size: 20px;
  font-family: "Poppins";
}

.homeListPlayIcon {
  width: 10px;
  height: 10px;
}

html {
  touch-action: manipulation;
}

.paddingTop {
  /* padding-top: 56px; */
  min-height: calc(100% - 24px);
}

/* .paddingTopone {
  padding-top: 56px;
} */

.categoryHover {
  transform: scale(1);
  transition: transform 0.4s ease-in-out;
}

.rs-input {
  font-size: 14px;
}

.errorred {
  color: #ff0000 !important;
  font-size: 14px;
  margin-top: 10px;
  display: flex;
  font-family: 'Poppins';
}

.noRecord {
  display: flex;
  justify-content: center;
  font-size: 17px;
  font-weight: bold;
  padding: 10px;
}

.css-1nmdiq5-menu:hover {
  background-color: #ff0000 !important;
  color: #ff0000 !important;
}

.css-13cymwt-control {
  padding: 5px 0 5px 0;
  border-radius: 5px;
}

.css-b62m3t-container {
  border-radius: 5px;
}

.css-t3ipsp-control {
  padding: 5px 0 5px 0;
  border-radius: 5px;
}

.overlay-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(2px);
}

.overlay-icon {
  font-size: 25px;
  color: #ffffff;
}

.thumbnails-images {
  width: auto;
  height: 100px;
}

.modal {
  scrollbar-width: none;
}

.hideArrow::after {
  border: none;
}

.absolute-mobile-link {
  position: absolute;
  inset: 0;
  z-index: 3;
}


.comment-avatar {
  width: 50px;
  height: 50px;
}

.comment-name {
  font-size: 20px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}

.comment-text {
  font-size: 18px;
  font-weight: 300;
  line-height: 30px;
  text-align: left;
}

.comment-icon {
  font-size: 20px;
  /* Default for larger screens */
}

@media (max-width: 576px) {
  .comment-icon {
    font-size: 16px;
    /* Smaller size for small/mobile devices */
  }
}

.cursor-pointer {
  cursor: pointer;
}

.artist-name-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
  /* match your image width or adjust accordingly */
  /* display: inline-block; */
}


.square {
  background: rgba(130, 130, 130, 0.2);
  background: linear-gradient(to right,
      rgba(130, 130, 130, 0.2) 8%,
      rgba(130, 130, 130, 0.3) 18%,
      rgba(130, 130, 130, 0.2) 33%);
  background-size: 800px 100px;
  animation: wave-squares 2s infinite ease-out;
}

.languageColorAfter::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
}

.languageText {
  font-family: "Poppins";
  font-size: 20px;
  font-weight: 600;
  line-height: 38px;
  position: absolute;
  bottom: 16px;
  z-index: 1;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}

.mandatory {
  color: #ff0000;
}

.cursor-pointer {
  cursor: pointer;
}

.rent_video_page_ul_li ul {
  list-style-type: disclosure-closed !important;
}

.maintancesLogo {
  width: 200px;
}

.priceLabel {
  top: 0px;
  left: 0px;
  z-index: 1;
  padding: 6px 10px;
  height: 30px;
}


.topTenMovies {
  position: absolute;
  top: 10px;
  left: 4px;
  z-index: 2;
  width: 40%;
  height: 60%;
  pointer-events: none;
}

.topTenMovies img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: top left;
  display: block;
  pointer-events: none;
}

.topTenMovies span {
  position: absolute;
  top: -10px;
  left: 10px;
  color: transparent;
  -webkit-text-stroke: 2px rgb(255, 255, 255);
  font-size: 65px;
  font-weight: bold;
}

.priceText {
  font-size: 13px;
  height: 19px;
}

@keyframes wave-squares {
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
}

.Toastify__toast-body {
  font-family: "Poppins";
  font-weight: 500;
}

.border-solid {
  border-style: solid;
}

.bottom-border {
  border-bottom-width: 2px;
  border-bottom-style: solid;
  border-top: 0;
  border-left: 0;
  border-right: 0;
}

.border-width {
  border-width: 1px;
}

.button-color {
  color: #fff !important;
}

.button-bg-color {
  background-color: var(--btn-color) !important;
}

.css-wsp0cs-MultiValueGeneric {
  font-family: "Poppins" !important;
}

.bg-image-gradian::before {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.Toastify__toast-container {
  z-index: 99999;
}

.before-star::after {
  position: absolute;
  content: "*";
  color: red;
}

button:focus {
  outline: none !important;
}

button.Toastify__close-button {
  background-color: transparent !important;
}

.loaderFixed {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
}

/* .loader {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader span {
  width: 10px;
  height: 10px;
  margin: 5px;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.2s infinite ease-in-out;
}

.loader span:nth-child(1) { background: #0D47A1; animation-delay: 0s; }
.loader span:nth-child(2) { background: #1565C0; animation-delay: 0.2s; }
.loader span:nth-child(3) { background: #1E88E5; animation-delay: 0.4s; }
.loader span:nth-child(4) { background: #42A5F5; animation-delay: 0.6s; }
.loader span:nth-child(5) { background: #90CAF9; animation-delay: 0.8s; }  

@keyframes bounce {
  0%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-15px);
  }
} */

.loader {
  transform: translate(-50%, -50%);
  width: 70px;
  height: 70px;
  background: transparent;
  border: 3px solid #3c3c3c;
  border-radius: 50%;
  text-align: center;
  line-height: 70px;
  font-family: sans-serif;
  font-size: 10px;
  color: #ff0000;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  text-shadow: 0 0 10px #ff0000;
  box-shadow: 0 0 20px rgba(0, 0, 0, .5);
}

.loader:before {
  content: '';
  position: absolute;
  top: -3px;
  left: -3px;
  width: 110%;
  height: 110%;
  border: 3px solid transparent;
  border-top: 3px solid #ff0000;
  border-right: 3px solid #ff0000;
  border-radius: 50%;
  animation: animateC 2s linear infinite;
}

.loader span {
  display: block;
  position: absolute;
  top: calc(50% - 2px);
  left: 50%;
  width: 50%;
  height: 4px;
  background: transparent;
  transform-origin: left;
  animation: animate 2s linear infinite;
}

.loader span:before {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ff0000;
  top: -6px;
  right: -8px;
  box-shadow: 0 0 20px #ff0000;
}

.modalBackdropdataserviceunavailable {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background-color: rgba(0, 0, 0, 0.6); */
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10007;
}

.modalContentdataserviceunavailable {
  /* background-color: #fff; */
  padding: 2rem;
  opacity: 1;
  border-radius: 10px;
  max-width: 700px;
  text-align: center;
}

.counter_timing {
  border-radius: 0.8em;
  -moz-border-radius: 0.8em;
  display: inline-block;
  line-height: 1.6em;
  margin-left: 20px;
  text-align: center;
  width: 1.6em;
}

.banner-image {
  background-repeat: no-repeat;
  background-position: center;
}

@media (max-width: 767px) {
  .banner-image {
    background-size: cover;
    background-position: center;
  }
}

.page-wrapper {
  min-height: 100vh;
}

.page-title {
  font-size: 2.2rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 10px;
}

.title-underline {
  width: 60px;
  height: 4px;
  border-radius: 10px;
  background: currentColor;
}

.content-card {
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  background: transparent;
  padding: 0;
}

.page-content {
  font-size: 16px;
  line-height: 1.9;
  letter-spacing: 0.2px;
  text-align: left;
  word-break: normal;
  overflow-wrap: break-word;
}

.page-content p {
  margin-bottom: 18px;
}

.page-content h1,
.page-content h2,
.page-content h3 {
  margin-top: 32px;
  margin-bottom: 12px;
  font-weight: 600;
}

.page-content ul {
  margin: 16px 0 24px 20px;
}

.page-content li {
  margin-bottom: 10px;
}

.page-content * {
  color: inherit;
}

@media (max-width: 768px) {
  .content-card {
    max-width: 100%;
    padding: 0 18px;
  }

  .page-title {
    font-size: 1.6rem;
  }

  .page-content {
    font-size: 15px;
    line-height: 1.75;
    letter-spacing: 0;
  }

  .page-content h1:first-child {
    display: none;
  }
}

@keyframes animateC {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes animate {
  0% {
    transform: rotate(45deg);
  }

  100% {
    transform: rotate(405deg);
  }
}

.header-logo_logo {
  width: 100%;
  height: 100%;
}

img.position-relative.d-block.opacity-100.undefined {
  width: 200px !important;
  height: 40px !important;
}

img.position-relative.d-block.opacity-100.undefined.title_image {
  width: 100px !important;
  height: 50px !important;
}

@keyframes loaderCustom {
  100% {
    transform: rotate(1turn)
  }
}

.onlineStatus {
  position: fixed;
  top: -50px;
  left: 0;
  right: 0;
  width: 100%;
  text-align: center;
  padding: 10px 15px;
  color: white;
  margin: 0 auto;
  max-width: 190px;
  border-radius: 8px;
  height: 41px;
  z-index: 9999;
  animation: onlineAni 0.08s linear both;
}

@keyframes onlineAni {
  0% {
    top: -50px;
  }

  100% {
    top: 70px;
  }
}

.button-btn {
  background-color: #0fcc1c;
}

.sendcode {
  font-size: 19px;
  font-weight: 600;
}

@media screen and (max-width: 565px) {
  .heightForChild {
    padding-top: 60px;
  }
}

@media screen and (max-width: 1024px) {
  .homeListImage {
    height: 100px;
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* =====================================================
   Shorts & UGC Watch Page — NexusPlayer embedded fix
   ===================================================== */

.shorts-player-wrapper,
.ugc-player-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 12px;
  overflow: hidden;
  /* contain: layout makes this div the containing block
     for any absolute/fixed children inside NexusPlayer */
  contain: layout;
}

/* Only target the FIRST direct child (NexusPlayer's root div).
   This forces it into the wrapper without touching any inner
   controls, overlays or hover elements. */
.shorts-player-wrapper>div:first-child,
.ugc-player-wrapper>div:first-child {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
}

/* Ensure the video element itself fills the container */
.shorts-player-wrapper video,
.ugc-player-wrapper video {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain;
}

/* On mobile, stack the player full-width */
@media (max-width: 991px) {

  .shorts-watch-page .row,
  .ugc-watch-page .row {
    flex-direction: column;
  }

  .shorts-player-wrapper,
  .ugc-player-wrapper {
    border-radius: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;AACpB;;;AAGA;;EAEE,yBAAyB;EACzB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;AACpB;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,MAAM;EACN,OAAO;EACP,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb;AACF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EAEzB,mBAAmB;AACrB;;AAEA;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,+CAA+C;EAC/C,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,0CAA0C;AAC5C;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;;AAGA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE;IACE,eAAe;IACf,0CAA0C;EAC5C;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,iDAAiD;EACjD,2BAA2B;AAC7B;;;AAGA;EACE,oCAAoC;EAOpC;;;mCAGiC;EACjC,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,YAAY;AACd;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4BG;;AAEH;EACE,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;0DAE0D;;AAE1D;;EAEE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB;yDACuD;EACvD,eAAe;AACjB;;AAEA;;0CAE0C;AAC1C;;EAEE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,wDAAwD;AACxD;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;;EAEE;;IAEE,sBAAsB;EACxB;;EAEA;;IAEE,kBAAkB;EACpB;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n\n@font-face {\n  font-display: swap;\n}\n\n\nbody,\n#root {\n  background-color: #000000;\n  margin: 0;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n\n.modal-backdrop.show {\n  opacity: 0 !important;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 0 !important;\n  --bs-backdrop-bg: #1f222a;\n  --bs-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: none !important;\n  width: 100vw;\n  height: 100vh;\n  background-color: none !important\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background-color: #f0f0f0;\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n  background: #424242;\n}\n\n:is(button, p, input, label, span, select) {\n  font-family: \"Poppins\";\n}\n\n:is(h1, h2, h3, h4, h5, h6) {\n  font-family: \"Poppins\" !important;\n}\n\n.heightBody {\n  height: 100vh;\n}\n\n/* .heightForChild {\n  padding-top: 20px;\n} */\n\n.width-max {\n  width: max-content;\n}\n\n.input-label {\n  display: block;\n  position: absolute;\n  top: 0;\n  font-weight: 300;\n  font-size: 20px;\n  font-family: \"Poppins\";\n}\n\n.loaderAll {\n  height: 100vh;\n  width: 100%;\n}\n\n.loaderAll>img {\n  width: 150px;\n  height: 150px;\n  object-fit: cover;\n}\n\n.bannerText {\n  font-family: \"Poppins\" !important;\n  font-size: 10px !important;\n  font-weight: 500 !important;\n  line-height: 13px !important;\n  position: relative !important;\n  background-color: rgb(45 48 56 / 0%) !important;\n  border: 1px solid white !important;\n}\n\n.donate-tab {\n  position: fixed;\n  right: 0;\n  top: 20vh;\n  z-index: 1040;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  padding: 10px;\n  border: none;\n  border-radius: 10px 0 0 10px;\n  cursor: pointer;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);\n}\n\n/* Vertical text: bottom to top */\n.donate-tab .label {\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  font-weight: 600;\n  font-size: 15px;\n  letter-spacing: 1px;\n}\n\n.heart-icon {\n  transform: rotate(-90deg);\n}\n\n\n.homePageCardHeading {\n  font-family: \"Poppins\";\n  font-size: 13px;\n  line-height: 16px;\n  font-weight: 600;\n  margin-bottom: 0px;\n  height: 16px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  white-space: nowrap;\n}\n\n.homePageCardHeading::after {\n  display: none;\n}\n\n.homeListImage {\n  width: 100%;\n  height: 180px;\n  object-fit: cover;\n  position: relative;\n}\n\n.homeListImage::after {\n  content: \"\";\n  width: 100%;\n  display: block;\n  position: absolute;\n  bottom: 0;\n  height: 70%;\n}\n\n.homeListImage.active::after {\n  height: 40%;\n}\n\n.homeLiveImage {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 3px;\n}\n\n.homeListContent {\n  z-index: 1;\n}\n\n.homeListButton {\n  padding: 10px 15px;\n  border-radius: 5px;\n  width: 100%;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.homeListButtonText {\n  font-family: \"Poppins\";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: 0em;\n}\n\n\n.homeListText {\n  font-size: 20px;\n  font-family: \"Poppins\";\n}\n\n.homeListPlayIcon {\n  width: 10px;\n  height: 10px;\n}\n\nhtml {\n  touch-action: manipulation;\n}\n\n.paddingTop {\n  /* padding-top: 56px; */\n  min-height: calc(100% - 24px);\n}\n\n/* .paddingTopone {\n  padding-top: 56px;\n} */\n\n.categoryHover {\n  transform: scale(1);\n  transition: transform 0.4s ease-in-out;\n}\n\n.rs-input {\n  font-size: 14px;\n}\n\n.errorred {\n  color: #ff0000 !important;\n  font-size: 14px;\n  margin-top: 10px;\n  display: flex;\n  font-family: 'Poppins';\n}\n\n.noRecord {\n  display: flex;\n  justify-content: center;\n  font-size: 17px;\n  font-weight: bold;\n  padding: 10px;\n}\n\n.css-1nmdiq5-menu:hover {\n  background-color: #ff0000 !important;\n  color: #ff0000 !important;\n}\n\n.css-13cymwt-control {\n  padding: 5px 0 5px 0;\n  border-radius: 5px;\n}\n\n.css-b62m3t-container {\n  border-radius: 5px;\n}\n\n.css-t3ipsp-control {\n  padding: 5px 0 5px 0;\n  border-radius: 5px;\n}\n\n.overlay-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9998;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  backdrop-filter: blur(2px);\n}\n\n.overlay-icon {\n  font-size: 25px;\n  color: #ffffff;\n}\n\n.thumbnails-images {\n  width: auto;\n  height: 100px;\n}\n\n.modal {\n  scrollbar-width: none;\n}\n\n.hideArrow::after {\n  border: none;\n}\n\n.absolute-mobile-link {\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n}\n\n\n.comment-avatar {\n  width: 50px;\n  height: 50px;\n}\n\n.comment-name {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 36px;\n  text-align: left;\n}\n\n.comment-text {\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 30px;\n  text-align: left;\n}\n\n.comment-icon {\n  font-size: 20px;\n  /* Default for larger screens */\n}\n\n@media (max-width: 576px) {\n  .comment-icon {\n    font-size: 16px;\n    /* Smaller size for small/mobile devices */\n  }\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.artist-name-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 120px;\n  /* match your image width or adjust accordingly */\n  /* display: inline-block; */\n}\n\n\n.square {\n  background: rgba(130, 130, 130, 0.2);\n  background: -webkit-gradient(linear,\n      left top,\n      right top,\n      color-stop(8%, rgba(130, 130, 130, 0.2)),\n      color-stop(18%, rgba(130, 130, 130, 0.3)),\n      color-stop(33%, rgba(130, 130, 130, 0.2)));\n  background: linear-gradient(to right,\n      rgba(130, 130, 130, 0.2) 8%,\n      rgba(130, 130, 130, 0.3) 18%,\n      rgba(130, 130, 130, 0.2) 33%);\n  background-size: 800px 100px;\n  animation: wave-squares 2s infinite ease-out;\n}\n\n.languageColorAfter::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  content: \"\";\n}\n\n.languageText {\n  font-family: \"Poppins\";\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 38px;\n  position: absolute;\n  bottom: 16px;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.mandatory {\n  color: #ff0000;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.rent_video_page_ul_li ul {\n  list-style-type: disclosure-closed !important;\n}\n\n.maintancesLogo {\n  width: 200px;\n}\n\n.priceLabel {\n  top: 0px;\n  left: 0px;\n  z-index: 1;\n  padding: 6px 10px;\n  height: 30px;\n}\n\n\n.topTenMovies {\n  position: absolute;\n  top: 10px;\n  left: 4px;\n  z-index: 2;\n  width: 40%;\n  height: 60%;\n  pointer-events: none;\n}\n\n.topTenMovies img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: top left;\n  display: block;\n  pointer-events: none;\n}\n\n.topTenMovies span {\n  position: absolute;\n  top: -10px;\n  left: 10px;\n  color: transparent;\n  -webkit-text-stroke: 2px rgb(255, 255, 255);\n  font-size: 65px;\n  font-weight: bold;\n}\n\n.priceText {\n  font-size: 13px;\n  height: 19px;\n}\n\n@keyframes wave-squares {\n  0% {\n    background-position: -468px 0;\n  }\n\n  100% {\n    background-position: 468px 0;\n  }\n}\n\n.Toastify__toast-body {\n  font-family: \"Poppins\";\n  font-weight: 500;\n}\n\n.border-solid {\n  border-style: solid;\n}\n\n.bottom-border {\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n}\n\n.border-width {\n  border-width: 1px;\n}\n\n.button-color {\n  color: #fff !important;\n}\n\n.button-bg-color {\n  background-color: var(--btn-color) !important;\n}\n\n.css-wsp0cs-MultiValueGeneric {\n  font-family: \"Poppins\" !important;\n}\n\n.bg-image-gradian::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.Toastify__toast-container {\n  z-index: 99999;\n}\n\n.before-star::after {\n  position: absolute;\n  content: \"*\";\n  color: red;\n}\n\nbutton:focus {\n  outline: none !important;\n}\n\nbutton.Toastify__close-button {\n  background-color: transparent !important;\n}\n\n.loaderFixed {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 99999;\n}\n\n/* .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loader span {\n  width: 10px;\n  height: 10px;\n  margin: 5px;\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounce 1.2s infinite ease-in-out;\n}\n\n.loader span:nth-child(1) { background: #0D47A1; animation-delay: 0s; }\n.loader span:nth-child(2) { background: #1565C0; animation-delay: 0.2s; }\n.loader span:nth-child(3) { background: #1E88E5; animation-delay: 0.4s; }\n.loader span:nth-child(4) { background: #42A5F5; animation-delay: 0.6s; }\n.loader span:nth-child(5) { background: #90CAF9; animation-delay: 0.8s; }  \n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-15px);\n  }\n} */\n\n.loader {\n  transform: translate(-50%, -50%);\n  width: 70px;\n  height: 70px;\n  background: transparent;\n  border: 3px solid #3c3c3c;\n  border-radius: 50%;\n  text-align: center;\n  line-height: 70px;\n  font-family: sans-serif;\n  font-size: 10px;\n  color: #ff0000;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  text-shadow: 0 0 10px #ff0000;\n  box-shadow: 0 0 20px rgba(0, 0, 0, .5);\n}\n\n.loader:before {\n  content: '';\n  position: absolute;\n  top: -3px;\n  left: -3px;\n  width: 110%;\n  height: 110%;\n  border: 3px solid transparent;\n  border-top: 3px solid #ff0000;\n  border-right: 3px solid #ff0000;\n  border-radius: 50%;\n  animation: animateC 2s linear infinite;\n}\n\n.loader span {\n  display: block;\n  position: absolute;\n  top: calc(50% - 2px);\n  left: 50%;\n  width: 50%;\n  height: 4px;\n  background: transparent;\n  transform-origin: left;\n  animation: animate 2s linear infinite;\n}\n\n.loader span:before {\n  content: '';\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #ff0000;\n  top: -6px;\n  right: -8px;\n  box-shadow: 0 0 20px #ff0000;\n}\n\n.modalBackdropdataserviceunavailable {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  /* background-color: rgba(0, 0, 0, 0.6); */\n  opacity: 0.9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10007;\n}\n\n.modalContentdataserviceunavailable {\n  /* background-color: #fff; */\n  padding: 2rem;\n  opacity: 1;\n  border-radius: 10px;\n  max-width: 700px;\n  text-align: center;\n}\n\n.counter_timing {\n  border-radius: 0.8em;\n  -moz-border-radius: 0.8em;\n  display: inline-block;\n  line-height: 1.6em;\n  margin-left: 20px;\n  text-align: center;\n  width: 1.6em;\n}\n\n.banner-image {\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n@media (max-width: 767px) {\n  .banner-image {\n    background-size: cover;\n    background-position: center;\n  }\n}\n\n.page-wrapper {\n  min-height: 100vh;\n}\n\n.page-title {\n  font-size: 2.2rem;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.title-underline {\n  width: 60px;\n  height: 4px;\n  border-radius: 10px;\n  background: currentColor;\n}\n\n.content-card {\n  max-width: 900px;\n  width: 100%;\n  margin: 0 auto;\n  background: transparent;\n  padding: 0;\n}\n\n.page-content {\n  font-size: 16px;\n  line-height: 1.9;\n  letter-spacing: 0.2px;\n  text-align: left;\n  word-break: normal;\n  overflow-wrap: break-word;\n}\n\n.page-content p {\n  margin-bottom: 18px;\n}\n\n.page-content h1,\n.page-content h2,\n.page-content h3 {\n  margin-top: 32px;\n  margin-bottom: 12px;\n  font-weight: 600;\n}\n\n.page-content ul {\n  margin: 16px 0 24px 20px;\n}\n\n.page-content li {\n  margin-bottom: 10px;\n}\n\n.page-content * {\n  color: inherit;\n}\n\n@media (max-width: 768px) {\n  .content-card {\n    max-width: 100%;\n    padding: 0 18px;\n  }\n\n  .page-title {\n    font-size: 1.6rem;\n  }\n\n  .page-content {\n    font-size: 15px;\n    line-height: 1.75;\n    letter-spacing: 0;\n  }\n\n  .page-content h1:first-child {\n    display: none;\n  }\n}\n\n@keyframes animateC {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes animate {\n  0% {\n    transform: rotate(45deg);\n  }\n\n  100% {\n    transform: rotate(405deg);\n  }\n}\n\n.header-logo_logo {\n  width: 100%;\n  height: 100%;\n}\n\nimg.position-relative.d-block.opacity-100.undefined {\n  width: 200px !important;\n  height: 40px !important;\n}\n\nimg.position-relative.d-block.opacity-100.undefined.title_image {\n  width: 100px !important;\n  height: 50px !important;\n}\n\n@keyframes loaderCustom {\n  100% {\n    transform: rotate(1turn)\n  }\n}\n\n.onlineStatus {\n  position: fixed;\n  top: -50px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  text-align: center;\n  padding: 10px 15px;\n  color: white;\n  margin: 0 auto;\n  max-width: 190px;\n  border-radius: 8px;\n  height: 41px;\n  z-index: 9999;\n  animation: onlineAni 0.08s linear both;\n}\n\n@keyframes onlineAni {\n  0% {\n    top: -50px;\n  }\n\n  100% {\n    top: 70px;\n  }\n}\n\n.button-btn {\n  background-color: #0fcc1c;\n}\n\n.sendcode {\n  font-size: 19px;\n  font-weight: 600;\n}\n\n@media screen and (max-width: 565px) {\n  .heightForChild {\n    padding-top: 60px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .homeListImage {\n    height: 100px;\n  }\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* =====================================================\n   Shorts & UGC Watch Page — NexusPlayer embedded fix\n   ===================================================== */\n\n.shorts-player-wrapper,\n.ugc-player-wrapper {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  border-radius: 12px;\n  overflow: hidden;\n  /* contain: layout makes this div the containing block\n     for any absolute/fixed children inside NexusPlayer */\n  contain: layout;\n}\n\n/* Only target the FIRST direct child (NexusPlayer's root div).\n   This forces it into the wrapper without touching any inner\n   controls, overlays or hover elements. */\n.shorts-player-wrapper>div:first-child,\n.ugc-player-wrapper>div:first-child {\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  max-width: 100% !important;\n  max-height: 100% !important;\n}\n\n/* Ensure the video element itself fills the container */\n.shorts-player-wrapper video,\n.ugc-player-wrapper video {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: contain;\n}\n\n/* On mobile, stack the player full-width */\n@media (max-width: 991px) {\n\n  .shorts-watch-page .row,\n  .ugc-watch-page .row {\n    flex-direction: column;\n  }\n\n  .shorts-player-wrapper,\n  .ugc-player-wrapper {\n    border-radius: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
